import React, { useEffect } from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { getKey } from "../../helpers/sessionKey";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../constant/Endpoint";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FileText, Folder } from "lucide-react";
import Options from "../Reusable/OptionsPopOver";
import FileOptions from "../Reusable/FileOptions";

const TableView = (props: any) => {
  const {
    setSelected,
    setOpenRenameFolderPopup,
    handleDeleteFolder,
    isDeleting,
    handleDeleteFile,
    setOpenRenameFilePopup,
    isdeleteLoading,
  } = props;

  const navigate = useNavigate();
  const id = getKey("user");
  const [searchParams, setSearchParams] = useSearchParams();
  const limit = parseInt(searchParams.get("limit") || "10", 10);

  useEffect(() => {
    if (!searchParams.get("limit")) {
      searchParams.set("limit", "10");
      setSearchParams(searchParams);
    }
  }, []);

  const { data: fileList = [], isLoading } = useGetHook({
    queryKey: ["file", `file-${id}`],
    url: `${APIS.FILE}`,
    params: { object_id: id },
  });

  const { data: folderList = [], isLoading: isFolderLoading } = useGetHook({
    queryKey: ["folder"],
    url: `${APIS.FOLDER}`,
    params: { parent__isnull: true },
  });

  const folders = folderList.map((folder: any) => ({
    ...folder,
    _type: "folder",
  }));
  const files = fileList.map((file: any) => ({ ...file, _type: "file" }));
  const combined = [...folders, ...files];
  const visible = combined.slice(0, limit);

  return (
    <div className={tw`mt-4`}>
      <table className={tw`w-full table-auto text-left`}>
        <thead className={tw`border-b`}>
          <tr>
            <th className={tw`px-4 py-2`}>Name</th>
            <th className={tw`px-4 py-2`}>Upload Date</th>
            <th className={tw`px-4 py-2`}>Created By</th>
            <th className={tw`px-4 py-2`}>Location</th>
            <th className={tw`px-4 py-2`}></th>
          </tr>
        </thead>
        <tbody>
          {isLoading || isFolderLoading
            ? Array.from({ length: 10 }).map((_, i) => (
                <tr key={i} className={tw`border-b`}>
                  <td className={tw`px-4 py-2`}>
                    <div
                      className={tw`w-40 h-4 bg-gray-200 animate-pulse rounded`}
                    ></div>
                  </td>
                  <td className={tw`px-4 py-2`}>
                    <div
                      className={tw`w-24 h-4 bg-gray-200 animate-pulse rounded`}
                    ></div>
                  </td>
                  <td className={tw`px-4 py-2`}>
                    <div
                      className={tw`w-20 h-4 bg-gray-200 animate-pulse rounded`}
                    ></div>
                  </td>
                  <td className={tw`px-4 py-2`}>
                    <div
                      className={tw`w-20 h-4 bg-gray-200 animate-pulse rounded`}
                    ></div>
                  </td>
                  <td className={tw`px-4 py-2`}></td>
                </tr>
              ))
            : visible.map((item: any) => {
                const isFolder = item._type === "folder";
                const title = item.title;
                const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(title);

                return (
                  <tr
                    key={item.id}
                    className={tw`border-b hover:bg-gray-100 cursor-pointer`}
                    onClick={() => {
                      if (isFolder) navigate(`folder/${item.id}`);
                    }}
                  >
                    <td className={tw`px-4 py-2 flex items-center gap-2`}>
                      {isFolder ? (
                        <Folder />
                      ) : isImage ? (
                        <img
                          src={item.file}
                          alt={title}
                          className={tw`w-5 h-5 object-cover rounded-sm`}
                        />
                      ) : (
                        <FileText className={tw`text-blue-400 w-5 h-5`} />
                      )}
                      <span>{title}</span>
                    </td>
                    <td className={tw`px-4 py-2`}>{item.uploadedAt || "—"}</td>
                    <td className={tw`px-4 py-2`}>–</td>
                    <td className={tw`px-4 py-2`}>–</td>
                    <td className={tw`px-4 py-2`}>
                      {isFolder ? (
                        <Options
                          setSelected={setSelected}
                          folder={item}
                          setOpenRenameFolderPopup={setOpenRenameFolderPopup}
                          handleDelete={handleDeleteFolder}
                          isdeleteLoading={isDeleting}
                        />
                      ) : (
                        <FileOptions
                          setSelected={setSelected}
                          file={item}
                          setOpenRenameFolderPopup={setOpenRenameFilePopup}
                          handleDelete={handleDeleteFile}
                          isdeleteLoading={isdeleteLoading}
                        />
                      )}
                    </td>
                  </tr>
                );
              })}
        </tbody>
      </table>

      {combined.length > limit && (
        <div className={tw`text-center mt-4`}>
          <button
            className={tw`px-4 py-2 bg-gray-200 rounded hover:bg-gray-300`}
            onClick={() => {
              const newLimit = limit + 10;
              searchParams.set("limit", newLimit.toString());
              setSearchParams(searchParams);
            }}
          >
            View More
          </button>
        </div>
      )}
    </div>
  );
};

export default TableView;
